import { useContext } from 'react';
import { SnackbarContext } from '../contexts/SnackbarContext';

const useSnackbars = () => useContext(SnackbarContext);

export default useSnackbars;
